/* GESTION DU MENU MOBILE */

const valueResponsiveMenu = 1120; // valeur du breakpoint sous lequel le menu mobile s'active
let $witdhWindow;

// les events
$(function () {
    $witdhWindow = $(window).width();
});

window.addEventListener('resize', function () {
    $witdhWindow = $(window).width();
});

$(document).on('click', '.menu-mobile-button', function () {
    let $thisItem = $(this);
    menuMobileToggle($witdhWindow, $thisItem);
});

$(document).on('click', '#menu-mobile > .menu-item', function (e) {
    let $thisItem = $(this);
    if ($thisItem.hasClass('menu-item-has-children') ) {
        e.preventDefault();
        menuMobileNavigation($witdhWindow, $thisItem);
    }
});


$(document).on('click', '#menu-mobile > .menu-item > .sub-menu', function (e) {
    e.stopPropagation();
});


// les fonctions

// Ouverture du menu mobimle
function menuMobileToggle($witdhWindow, $thisItem) {
    if ($witdhWindow <= valueResponsiveMenu) {
        let $submenu = $('#menu-mobile').find('> .sub-menu');

        if ($('#menu-mobile').hasClass('open')) {
            $('#menu-mobile').removeClass('open');
            $('body').removeClass('menu-mobile-open');
            $($thisItem).toggleClass('change');
        } else {
            $('#menu-mobile').addClass('open');
            $('body').addClass('menu-mobile-open');
            $($thisItem).toggleClass('change');

            //fermer les toggles actifs
            $submenu.hide();
            $submenu.removeClass('active-mobile');
            $submenu.parent('.menu-item').removeClass('active-mobile-parent');

        }
    }
}

// Navigation dans le menu mobile
function menuMobileNavigation($witdhWindow, $thisItem) {
    if ($witdhWindow <= valueResponsiveMenu) {

        $thisItem; //.menu-item CLIQUÉ
        let $allItemsMenu = $('#menu-mobile > .menu-item'); // TOUS LES .menu-item
        let $thisSubMenu = $thisItem.children('.sub-menu'); // .menu-item > .sub-menu CLIQUÉ
        let $allSubMenus = $('#menu-mobile > .menu-item > .sub-menu'); // TOUS LES  .menu-item > .sub-menu

        // ferme tous les .sub-menu 
        if ($thisItem.hasClass('active-mobile-parent')) {
            $thisItem.removeClass('active-mobile-parent');
            $thisSubMenu.slideUp(200);

            // ouvre le .sub-menu du .menu-item cliqué si celui si était fermé
        } else if ($thisItem.length !== 0 && (!$thisItem.hasClass('active-mobile-parent'))) {

            $allSubMenus.slideUp(200);
            $allItemsMenu.removeClass('active-mobile-parent');
            $thisItem.addClass('active-mobile-parent');
            $thisSubMenu.slideDown(200);


            // ferme le .sub-menu du .menu-item cliqué si celui-ci était ouvert
        } else {
            $thisItem.removeClass('active-mobile-parent');
            $thisSubMenu.slideUp(200);
        }
    }
}